export default __webpack_public_path__ + "static/media/support.dd89279a.svg";